<mj-record-form-container [Record]="record" [FormComponent]="this"
    (Navigate)="OnFormNavigate($event)"
    (DeleteRequested)="OnDeleteRequested()"
    (FavoriteToggled)="OnFavoriteToggled()"
    (HistoryRequested)="OnHistoryRequested()"
    (ListManagementRequested)="OnListManagementRequested()">

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="before-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <!-- ========================================
         FIELD PANELS
         ======================================== -->
    <!-- Details Section -->
    <mj-collapsible-panel
        SectionKey="details"
        SectionName="Details"
        Icon="fa fa-align-left"
        [Form]="this"
        [FormContext]="formContext">
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="_ParentID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="paymentLineItemID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="total"
            Type="number"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="totalInBaseCurrency"
            Type="number"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="_PulledAt"
            Type="datepicker"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="_RawJson"
            Type="textarea"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="CompanyIntegrationID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="CompanyID"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
            LinkType="Record"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_CreatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="__mj_UpdatedAt"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>
        <mj-form-field 
            [Record]="record"
            [ShowLabel]="true"
            FieldName="Credit"
            Type="textbox"
            [EditMode]="EditMode"
            [FormContext]="formContext"
        ></mj-form-field>

    </mj-collapsible-panel>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-fields" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>

    <mj-form-panel-slot Entity="{{record.EntityInfo.Name}}" Slot="after-related" [Record]="record" [FormComponent]="this" [FormContext]="formContext"></mj-form-panel-slot>
</mj-record-form-container>
        